import {Translate} from "../Translate";

const routesConfig = [
    {
        id: 'dashboard',
        title: Translate.dashboard,
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
    },
    {
        id: 'managePeople',
        title: Translate.managePeople,
        type: 'item',
        icon: 'people',
        url: '/manage/people/view/all',
        exact:true,
        roles: ['admin','supplier'],
    },
    {
        id: 'tickets',
        title: Translate.tickets,
        type: 'item',
        icon: 'chat',
        url: '/tickets',
        roles: ['user','supplier','agent'],
        feature:'tickets'
    },
    {
        id: 'manageComments',
        title: Translate.manageComments,
        type: 'item',
        icon: 'message',
        url: '/manage/comments',
        exact:true,
        roles: ['admin'],
    },
    {
        id: 'manageAbilities',
        title: Translate.manageAbilities,
        type: 'item',
        icon: 'category',
        url: '/manage/abilities',
        exact:true,
        roles: ['admin','supplier'],
    },
    {
        id: 'manageVisitors',
        title: Translate.manageVisitors,
        type: 'item',
        icon: 'monitoring',
        url: '/manage/visitors',
        exact:true,
        roles: ['admin'],
    },
    {
        id: 'manageVisits',
        title: Translate.manageVisits,
        type: 'item',
        icon: 'pageview',
        url: '/manage/visits',
        exact:true,
        roles: ['admin'],
    },
/*    {
        id: 'orders',
        roles: ['user'],
        title: Translate.ordersList,
        type: 'item',
        icon: 'shopping_cart',
        url: '/my-orders',
    },
    {
        id: 'wallet',
        title: Translate.myWallet,
        type: 'item',
        icon: 'account_balance_wallet',
        url: '/wallet/view',
        feature: 'wallet'
    },*/

   /* {
        id: 'productsList',
        title: Translate.productsList,
        type: 'item',
        icon: 'shopping_cart',
        url: '/my-products',
        roles: ['supplier'],
        feature: 'marketplace'
    },
    {
        id: 'makeProduct',
        title: Translate.makeProduct,
        type: 'item',
        icon:'shopping_bag',
        url: '/create/product',
        roles: ['supplier'],
        feature: 'marketplace'
    },*/
    /*{
        id: 'site_settings',
        title: Translate.siteSettings,
        type: 'collapse',
        icon: 'web',
        permission: 'manageSettings',
        children: [

            {
                id: 'siteInformation',
                title: Translate.siteInformation,
                type: 'item',
                icon: "chevron_left",
                url: '/setting/information',
                exact:true
            },
            {
                id: 'manageContacts',
                title: Translate.contactInformation,
                type: 'item',
                icon: "chevron_left",
                url: '/setting/contact',
                exact:true
            },
            {
                id: 'headerAndFooter',
                title: Translate.headerAndFooter,
                type: 'item',
                icon: "chevron_left",
                url: '/setting/header-footer',
                exact:true
            },
            /!*{
                id: 'translateFront',
                title: Translate.translateFront,
                type: 'item',
                url: '/settings/translate-front',
                exact:true
            },*!/
            {
                id: 'manageSlideShows',
                title: Translate.manageSlideShows,
                type: 'item',
                icon: "chevron_left",
                url: '/settings/slideshows',
                exact:true
            },
            {
                id: 'manageBanner',
                title: Translate.manageBanners,
                type: 'item',
                icon: "chevron_left",
                url: '/settings/banners',
                exact:true
            },
            {
                id: 'manageRedirects',
                title: Translate.manageRedirects,
                type: 'item',
                icon: "chevron_left",
                url: '/settings/redirects',
                exact:true,
                feature:"redirects"
            },
            /!*            {
                            id: 'manageTransferPricing',
                            title: Translate.manageTransferPricing,
                            type: 'item',
                            url: '/settings/transfer-pricing',
                            exact:true,

                        },*!/

            {
                id: 'customCode',
                title: Translate.custom_code,
                type: 'item',
                icon: "chevron_left",
                url: '/setting/custom-code',
                exact:true
            },

            {
                id: 'manageViolations',
                title: Translate.manageViolations,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/violations',
                exact:true,
                feature:"product_error_report"
            },

        ],

    },*/
    /*{
        id: 'manageProducts',
        title: Translate.manageProducts,
        type: 'collapse',
        icon: 'shopping_cart',
        permission: 'manageShops',
        children: [
            {
                id: 'manageProducts',
                title: Translate.productsList,
                type: 'item',
                url: '/manage/products',
                exact:true
            },
            {
                id: 'manageCategories',
                title: Translate.manageCategories,
                type: 'item',
                url: '/manage/categories',
                exact:true
            },
            {
                id: 'manageBrands',
                title: Translate.manageBrands,
                type: 'item',
                url: '/manage/brands',
                exact:true,
                feature: 'brands'
            },
            {
                id: 'manageVariables',
                title: Translate.manageVariables,
                type: 'item',
                url: '/manage/variables',
                exact:true
            },
            {
                id: 'manageAttributes',
                title: Translate.manageAttributes,
                type: 'item',
                url: '/manage/attributes',
                exact:true,
                feature: 'variable_products'
            },
            {
                id: 'manageComments',
                title: Translate.manageComments,
                type: 'item',
                url: '/manage/comments',
                exact:true
            },
        ],
    },*/
/*    {
        id: 'manageOrders',
        title: Translate.manageOrders,
        type: 'collapse',
        icon: 'receipt',
        permission: 'manageOrders',
        children: [
            {
                id: 'manageOrders',
                title: Translate.ordersList,
                type: 'item',
                url: '/manage/orders',
                exact:true
            },
            {
                id: 'manageDiscounts',
                title: Translate.manageDiscounts,
                type: 'item',
                url: '/manage/discounts',
                exact: true
            },
        ],
    },*/
    /*{
        id: 'usersManagement',
        title: Translate.usersManagement,
        type: 'collapse',
        icon: 'group',
        permission: 'manageSettings',
        children: [
            {
                id: 'agents',
                title: Translate.agentsManagement,
                type: 'item',
                url: '/manage/agents',
                exact:true,
                feature:"agent"
            },
            {
                id: 'allUsers',
                title: Translate.allUsers,
                type: 'item',
                url: '/manage/users/view/all',
                exact:true
            },
            {
                id: 'usersActivity',
                title: Translate.usersActivity,
                type: 'item',
                url: '/manage/activities',
                exact:true,
                feature:"activity_log"
            },

        ],
    },*/
/*    {
        id: 'manageMessages',
        title: Translate.manageMessages,
        type: 'collapse',
        icon: 'chat',
        permission: 'manageSettings',
        feature:"tickets",
        children: [
            {
                id: 'manageDepartments',
                title: Translate.manageTickets,
                type: 'item',
                url: '/manage/tickets',
                exact:true
            },
            {
                id: 'manageDepartments',
                title: Translate.manageDepartments,
                type: 'item',
                url: '/manage/departments',
                exact:true
            },

        ]
    },*/
/*    {
        id: 'managePages',
        title: Translate.managePages,
        type: 'item',
        icon: 'description',
        url: '/manage/pages',
        permission: 'manageSettings',
        /!*children: [

            {
                id: 'manageAbout',
                title: Translate.manageAbout,
                type: 'item',
                url: '/manage/pages/about',
                exact:true
            },
            {
                id: 'manageTerms',
                title: Translate.manageTerms,
                type: 'item',
                url: '/manage/pages/terms',
                exact:true
            },
            {
                id: 'managePrivacy',
                title: Translate.managePrivacyPolicy,
                type: 'item',
                url: '/manage/pages/privacy-policy',
                exact:true
            },
            {
                id: 'manageSellerTerms',
                title: Translate.manageSellerTerms,
                type: 'item',
                url: '/manage/pages/seller-terms',
                exact:true
            },
            {
                id: 'manageAgentTerms',
                title: Translate.manageAgentTerms,
                type: 'item',
                url: '/manage/pages/agent-terms',
                exact:true
            },
        ],*!/
    },
    {
        id: 'manageContact',
        title: Translate.manageContact,
        type: 'item',
        url: '/manage/contacts',
        icon: 'contact_mail',
        permission: 'manageSettings',
        exact:true
    },*/

/*    {
        id: 'paymentManagement',
        title: Translate.paymentManagement,
        type: 'collapse',
        icon: 'badge',
        permission: 'managePayments',
        feature:"wallet",
        children: [
            {
                id: 'manageVerifications',
                title: Translate.manageVerifications,
                type: 'item',
                url: '/manage/verifications',
                exact:true
            },
            {
                id: 'manageWallets',
                title: Translate.manageWallets,
                type: 'item',
                url: '/manage/wallets',
                exact:true,
            },

        ],
    },
    {
        id: 'blog',
        title: Translate.blog,
        type: 'collapse',
        icon: 'article',
        feature:"blog",
        children: [
            {
                id: 'contents',
                title: Translate.contents,
                type: 'item',
                url: '/manage/contents',
                exact:true
            },
            {
                id: 'makeContent',
                title: Translate.makeContent,
                type: 'item',
                url: '/create/content',
                exact:true,
            },
            {
                id: 'blogCategories',
                title: Translate.manageBlogCategories,
                type: 'item',
                url: '/manage/blog-categories',
                exact:true,
            },
            {
                id: 'manageBlogComments',
                title: Translate.manageBlogComments,
                type: 'item',
                url: '/manage/blog-comments',
                exact:true,
            },
        ],
    },*/
/*    {
        id: 'myDetails',
        title: Translate.myDetails,
        type: 'collapse',
        icon: 'person',
        children: [
            {
                id: 'addresses',
                title: Translate.addresses,
                type: 'item',
                icon: 'map',
                url: '/account/address',
            },
            {
                id: 'settings',
                title: Translate.account,
                type: 'item',
                icon: 'person',
                url: '/account/details',
            },
            {
                id: 'password',
                title: Translate.changePassword,
                icon: 'password',
                type: 'item',
                url: '/account/password',
            },
            {
                id: 'verification',
                title: Translate.verificationDetails,
                icon: 'credit_card',
                type: 'item',
                url: '/account/verification',
                feature:"wallet"
            },
        ],
    },*/
    {
        id: 'fileManager',
        title: Translate.fileManager,
        type: 'item',
        icon: 'image',
        url: '/file-manager',
        roles: ['admin','support','supplier','product_manager'],
        permission: "fileManagerPage",
    },
/*    {
        id: 'manageTemplate',
        title: Translate.manageTemplate,
        type: 'item',
        icon: 'format_paint',
        url: '/manage/template',
        roles: ['admin'],
    },*/

];
export default routesConfig;
